import { FlexProps } from "@chakra-ui/react"
import { IconType } from "react-icons"
import {
  FiClipboard,
  FiHome,
  FiMap,
  FiSettings,
  // FiTrendingUp,
  FiUsers,
} from "react-icons/fi"

export interface NavItemProps extends FlexProps {
  name?: string,
  path: string,
  icon: IconType,
  children?: React.ReactNode
}

export const NavItems: Array<NavItemProps> = [
  { id: 'home', name: 'Inicio', icon: FiHome, path: '/' },
  { id: 'surveys', name: 'Encuestas', icon: FiClipboard, path: '/encuestas' },
  // { id: 'statistics', name: 'Estadísticas', icon: FiTrendingUp, path: '/estadisticas' },
  { id: 'collaborators', name: 'Colaboradores', icon: FiUsers, path: '/colaboradores' },
  { id: 'sections', name: 'Secciones', icon: FiMap, path: '/secciones' },
  { id: 'config', name: 'Ajustes', icon: FiSettings, path: '/ajustes' },
];
